{
  "shippingServices": {
    "ECONOMY": "Tiết kiệm",
    "STANDARD": "Tiêu chuẩn",
    "PRIORITY": "Ưu tiên",
    "GROUND": "Đường bộ",
    "INTL_STANDARD": "Quốc tế tiêu chuẩn",
    "INTL_EXPRESS": "Quốc tế nhanh",
    "NEXT_DAY": "Hỏa tốc",
    "INTERNATIONAL": "Quốc tế"
  },
  "shippingZones": {
    "US_DOMESTIC": "Nội địa Mỹ",
    "US_HAWAII_AK": "Hawaii & Alaska",
    "CANADA": "Canada",
    "EU": "Liên minh châu Âu",
    "UK": "Vương quốc Anh",
    "AUSTRALIA": "Úc",
    "REST_OF_WORLD": "Phần còn lại của thế giới"
  },
  "initialsAvatar": {
    "noImage": "Không có ảnh"
  },
  "shippingFees": {
    "title": "Phí vận chuyển",
    "description": "Bảng phí vận chuyển (Shipping Rate Engine v2) — theo quốc gia đích / lưới ZIP3 của Mỹ + ngoại lệ ZIP5."
  },
  "blueprintCost": {
    "title": "Chi phí Blueprint",
    "description": "Chỉ xem — chi phí sản xuất của nhà cung cấp cho từng biến thể blueprint. Chi phí được quản lý ở phía nhà cung cấp (gán năng lực / duyệt sản phẩm); nhấp vào tên để mở trang Chi tiết blueprint.",
    "search": "Tìm kiếm",
    "searchPlaceholder": "Tìm theo blueprint, SKU hoặc nhà cung cấp…",
    "error": "Không tải được chi phí blueprint.",
    "empty": "Không có chi phí blueprint nào khớp bộ lọc hiện tại.",
    "columns": {
      "blueprint": "Blueprint",
      "variantSku": "SKU biến thể",
      "vendor": "Nhà cung cấp",
      "productionCost": "Chi phí sản xuất",
      "seasonalCost": "Chi phí theo mùa",
      "procDays": "Số ngày SX",
      "quality": "Chất lượng",
      "country": "Quốc gia",
      "status": "Trạng thái"
    },
    "statusLabels": {
      "approved": "Đã duyệt",
      "pending_approval": "Chờ duyệt",
      "rejected": "Từ chối"
    },
    "pagination": {
      "prev": "Trước",
      "next": "Sau"
    }
  },
  "pricesV2": {
    "title": "Bảng giá",
    "subtitle": "Xem sản phẩm kèm giá theo hạng",
    "exportAll": "Xuất tất cả",
    "networkError": "Không tải được giá.",
    "empty": "Không có blueprint nào khớp",
    "searchPlaceholder": "Tìm sản phẩm hoặc SKU…",
    "allTiers": "Tất cả hạng",
    "selectBlueprint": "Chọn {{name}}",
    "selectVariant": "Chọn {{sku}}",
    "variantsBadge_one": "{{count}} biến thể",
    "variantsBadge_other": "{{count}} biến thể",
    "stats": {
      "products": "Sản phẩm",
      "variants": "Biến thể",
      "skus": "SKU",
      "avgPrice": "Giá TB",
      "avgShipping": "Vận chuyển TB"
    },
    "expandAll": "Mở tất cả",
    "collapseAll": "Thu gọn tất cả",
    "shippingDisplay": "Vận chuyển",
    "shippingInMatrix": "Trong bảng",
    "shippingSidePanel": "Bảng bên",
    "viewShipping": "Vận chuyển",
    "table": {
      "sku": "SKU",
      "variant": "Biến thể",
      "pricing": "GIÁ",
      "shipping": "Vận chuyển",
      "fee": "Phí",
      "extra": "Thêm",
      "base": "Cơ bản"
    },
    "panel": {
      "title": "Phí vận chuyển",
      "method": "Phương thức",
      "fee": "Phí",
      "extra": "Thêm (từ cái 2)",
      "close": "Đóng",
      "empty": "Không có phí vận chuyển cho biến thể này."
    }
  },
  "configPage": {
    "title": "Cấu hình giá",
    "subtitle": "Phụ phí mùa vụ, quy tắc thêu, thuế/thuế quan và số hoá — áp dụng ở lần báo giá/xác nhận kế tiếp.",
    "readOnly": "Bạn cần quyền pricing:manage để sửa các thiết lập này.",
    "save": "Lưu cấu hình",
    "saving": "Đang lưu…",
    "savedToast": "Đã lưu cấu hình.",
    "errorToast": "Không thể lưu cấu hình.",
    "validationToast": "Vui lòng sửa các trường được đánh dấu.",
    "tabs": {
      "seasonal": "Mùa vụ",
      "embroidery": "Thêu",
      "tax": "Thuế & thuế quan",
      "digitizing": "Số hoá"
    },
    "seasonal": {
      "title": "Phụ phí mùa vụ",
      "variantIdLabel": "ID biến thể",
      "variantIdPlaceholder": "_id biến thể",
      "feeLabel": "Phí mùa vụ",
      "windowStartLabel": "Bắt đầu áp dụng",
      "windowEndLabel": "Kết thúc áp dụng",
      "bulkTitle": "Áp hàng loạt theo khoảng cân nặng",
      "weightMinLabel": "Cân nặng tối thiểu (g)",
      "weightMaxLabel": "Cân nặng tối đa (g)",
      "bulkFeeLabel": "Phí cần áp",
      "windowPassedReport": "Cảnh báo: phí mùa vụ lớn hơn 0 nhưng khoảng thời gian áp dụng đã kết thúc."
    },
    "embroidery": {
      "title": "Quy tắc mũi thêu",
      "minStitchesLabel": "Số mũi tối thiểu",
      "maxStitchesLabel": "Số mũi tối đa",
      "feeLabel": "Phí cho khoảng",
      "addRule": "Thêm quy tắc",
      "removeRule": "Xoá"
    },
    "tax": {
      "title": "Thuế quan đối ứng",
      "vendorIdLabel": "ID nhà cung cấp",
      "zoneLabel": "Vùng đích",
      "rateLabel": "Thuế trên mỗi đơn vị (USD)",
      "createTariff": "Tạo thuế quan",
      "blueprintIdLabel": "ID blueprint"
    },
    "digitizing": {
      "title": "Phí số hoá toàn cục",
      "feeLabel": "Phí số hoá",
      "helper": "Tính một lần cho mỗi thiết kế thêu mới."
    }
  },
  "skuPrices": {
    "title": "Bảng giá",
    "description": "Giá bán theo SKU và location cho mọi hạng đang hoạt động, kèm phí ship theo dịch vụ.",
    "search": {
      "placeholder": "Tìm blueprint, SKU hoặc biến thể",
      "aria": "Tìm giá"
    },
    "filters": {
      "location": "Location",
      "category": "Danh mục",
      "vendor": "Nhà cung cấp",
      "locationAria": "Lọc theo location",
      "categoryAria": "Lọc theo danh mục",
      "vendorAria": "Lọc theo nhà cung cấp",
      "clearHint": "Bấm lần nữa để bỏ lọc",
      "loadingOptions": "Đang tải…",
      "loadError": "Không tải được danh sách",
      "searchPlaceholder": "Tìm kiếm…",
      "searchAria": "Tìm trong danh sách",
      "noResults": "Không tìm thấy kết quả",
      "searchError": "Tìm kiếm thất bại. Hãy sửa hoặc xoá từ khoá.",
      "selectedFallback": "Đã chọn 1 mục"
    },
    "columns": {
      "blueprint": "Blueprint",
      "sku": "SKU",
      "variantName": "Tên biến thể",
      "location": "Location",
      "tax": "Thuế",
      "tiktok": "Tiktok",
      "status": "Trạng thái blueprint",
      "variantStatus": "Trạng thái biến thể",
      "shipFee": "Phí ship ({{service}})",
      "shipSeasonal": "Phụ phí mùa ({{service}})",
      "shipExtra": "Phí thêm ({{service}})",
      "shipTariff": "Thuế đối ứng ({{service}})",
      "shipParts": {
        "fee": "Phí ship",
        "seasonal": "Phụ phí mùa",
        "extra": "Phí thêm",
        "tariff": "Thuế đối ứng"
      },
      "toggle": "Cột",
      "reset": "Đặt lại cột",
      "saveError": "Không lưu được cách hiển thị cột. Đã hoàn tác."
    },
    "groups": {
      "pricing": "Giá bán",
      "shipping": "Vận chuyển: {{service}}"
    },
    "values": {
      "yes": "Có",
      "no": "Không"
    },
    "status": {
      "Draft": "Nháp",
      "PendingApproval": "Chờ duyệt",
      "Active": "Hoạt động",
      "Inactive": "Ngừng hoạt động",
      "Archived": "Đã lưu trữ",
      "InStock": "Còn hàng",
      "OutOfStock": "Hết hàng",
      "Discontinued": "Ngừng bán"
    },
    "blueprintStatus": {
      "Draft": "Nháp",
      "PendingApproval": "Chờ duyệt",
      "Active": "Hoạt động",
      "Inactive": "Ngừng hoạt động",
      "Archived": "Đã lưu trữ"
    },
    "variantStatus": {
      "InStock": "Còn hàng",
      "OutOfStock": "Hết hàng",
      "Discontinued": "Ngừng bán"
    },
    "empty": {
      "cell": "—",
      "list": "Không có giá nào khớp bộ lọc."
    },
    "error": {
      "load": "Không tải được bảng giá. Vui lòng thử lại."
    },
    "pagination": {
      "rowsPerPage": "Số dòng mỗi trang",
      "range": "Hiển thị {{from}}–{{to}} trên {{total}}",
      "prevPage": "Trang trước",
      "nextPage": "Trang sau",
      "aria": "Phân trang bảng giá"
    },
    "export": {
      "button": "Xuất file",
      "success": "Đã xuất {{count}} dòng.",
      "error": "Xuất file thất bại. Vui lòng thử lại."
    }
  }
}
